import {UserPreferencePreferredDevice} from "xchelper/models/userPreference.model";

export default class UserController {

  constructor ($scope, XucUser, $translate, CtiProxy, $state, forward, BrowserService, UserPreferenceService, $rootScope, WebHIDHeadsetService, ExternalEvent, remoteConfiguration) {

    $scope.user = {};
    $scope.connectedHIDDevice = WebHIDHeadsetService.getCurrentDeviceName();
    $rootScope.$on(ExternalEvent.WEBHID_DEVICE_SELECTED, (_, device) => {
      console.debug(`Received ${device} in UserController`);
      $scope.connectedHIDDevice = device;
      if (!$rootScope.$$phase) $scope.$apply();
    });

    if (BrowserService.browser === 'firefox' && CtiProxy.isUsingWebRtc()) {
      BrowserService.compatibilityAlert();
    }

    remoteConfiguration.getBoolean("showInternalNumber", false).then((value) => {      
      $scope.displayNumber = value;
    });

    XucUser.getUserAsync().then(function(user) {
      $scope.user = user;
    });
    $scope.forwarded_title = "";
    $translate('FORWARDED').then(function(transl) {
      $scope.forwarded_title = transl;
    });
    $translate('FORWARD_LABEL').then(function(transl) {
      $scope.forwarded_label = transl;
    });
    $translate('INTERNAL_NUMBER').then(function(transl) {
      $scope.internal_nb_label = transl;
    });
    $translate('NO_ANSWER_ABREV').then(function(transl) {
      $scope.na_abrev = transl;
    });
    $translate('BUSY_ABREV').then(function(transl) {
      $scope.busy_abrev = transl;
    });

    var buildForwardLabel = function(user) {
      var fwdLabel = $scope.forwarded_label;
      if ($scope.user.naFwdEnabled) {
        fwdLabel += ' ' + $scope.na_abrev;
      }
      if ($scope.user.busyFwdEnabled) {
        fwdLabel += ' ' + $scope.busy_abrev;
      }
      return fwdLabel + ' [' + forward.getDestination(user) + ']';
    };

    $scope.getLineNumber = function()  {
      return $scope.displayNumber ? '[' + CtiProxy.getLineNumber() + ']' : '';      
    };

    $scope.getNumberLabel = function() {
      if (!$scope.user.dndEnabled){
        if ($scope.user.uncFwdEnabled) return ($scope.forwarded_title + ' [' + forward.getDestination($scope.user) + ']');
        if ($scope.user.naFwdEnabled || $scope.user.busyFwdEnabled) {
          return buildForwardLabel($scope.user);
        }
        return $scope.internal_nb_label + ' ' + $scope.getLineNumber();
      }
      return forward.getDestination($scope.user) + ' ' + $scope.getLineNumber();
    };

    $scope.isDnd = () => $scope.user.dndEnabled;
    $scope.isForwarded = () => !$scope.user.dndEnabled && forward.isForwarded($scope.user);

    $scope.isWebRtcActive = function() {
      return CtiProxy.isUsingWebRtc();
    };

    $scope.getDisplayIcon = () => {
      let line = 'xivo-tel-fixe';
      if ($scope.isWebRtcActive()) {
        line = 'xivo-webrtc';

        let preferredDevice = UserPreferenceService.getPreferredDevice();
        if (CtiProxy.isUsingMobileApp() && !CtiProxy.isUsingUa()) {

          if (preferredDevice === UserPreferencePreferredDevice.MobileApp) {
            line = 'xivo-mobile';
          } else if (preferredDevice === UserPreferencePreferredDevice.WebAppAndMobileApp) {
            line += '-mobile';
          }

        }

        if ($scope.connectedHIDDevice && preferredDevice !== UserPreferencePreferredDevice.MobileApp ) {
          line += '-headset';
        }
      }

      if ($scope.user.dndEnabled) {
        return 'xivo-do-not-disturb';
      }

      return line;
    };

    $scope.$on("userConfigUpdated", function() {
      $scope.user = XucUser.getUser();
    });

    $scope.showMenu = function() {
      $state.go("interface.menu");
    };
  }
}
